<template>
  <section class="container">
    <section class="modal">
      <section class="header">
        <span>{{ title }}</span>
        <aha-icon
          @click="hide()"
          class="close-btn"
          name="close"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        />
      </section>
      <section class="content">
        <span class="message">{{ warningMessage }}:</span>
        <a :href="url" target="_blank" :title="url">{{ url }}</a>
      </section>
      <section class="footer">
        <button class="button-cancel" @click="hide()">
          <span class="font-bold">{{ $t("cancelButton") }}</span>
        </button>
      </section>
    </section>
  </section>
</template>
<script>

export default {
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      return this.$t('Leaving the presentation')
    },
    warningMessage() {
      return this.$t('This link will take you to a page that is not part of the presentation')
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>

<style scoped lang="scss">
.container {
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  background-color: hsla(0, 0%, 0%, 0.5);

  & > * {
    min-width: 150px;
    max-width: 350px;
    &.modal {
      box-sizing: border-box;
      background-color: white;
      padding: 1.5rem;
      overflow-wrap: break-word;
      border-radius: 10px;
      color: rgba(75, 75, 75);
      font-family: 'Nunito', sans-serif;

      & > .header {
        font-size: 1rem;
        font-weight: bold;
        margin-block-end: 1rem;
        display: flex;
        justify-content: space-between;

        & > .close-btn {
          cursor: pointer;
          color: rgba(153, 153, 153);
          transform: translateY(-10px);
        }
      }

      & > .content {
        font-size: 14px;
        margin-block-end: 1rem;

        & > .message {
          display: block;
          margin-block-end: 1rem;
        }

        & > a {
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      & > .footer {
        display: flex;
        justify-content:flex-end;
      }
    }
  }

  .button-cancel {
    --rem: 16;
    tab-size: 4;
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: rgb(40, 46, 62);
    --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    font-family: inherit;
    margin: 0;
    text-transform: none;
    background-image: none;
    cursor: pointer;
    -webkit-transform-style: preserve-3d;
    -webkit-backface-visibility: hidden;
    font-weight: 700;
    min-width: 2.5rem;
    --tw-text-opacity: 1;
    color: rgba(40, 46, 62, var(--tw-text-opacity));
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 100ms;
    border-radius: 9999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    --tw-bg-opacity: 1;
    background-color: rgba(247, 250, 252, var(--tw-bg-opacity));
    --tw-shadow: 0px 4px 0px #DFE3E9;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    height: 2.25rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    -webkit-appearance: button;
    padding: 8px 13px 3px 13px;

    &:hover:not(:active):not(:disabled) {
      --tw-shadow: 0px 3px 0px #DFE3E9;
      --tw-translate-y: 0.0625rem;
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }

    &:focus {
      outline: none !important;
    }

    &:active:not(:disabled) {
      --tw-bg-opacity: 1;
      background-color: rgba(180, 188, 207, var(--tw-bg-opacity));
      --tw-shadow: 0 0 #0000;
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      --tw-translate-y: 0.25rem;
    }
  }
}
</style>
